export function desgloseModalLiterals(t: any) {
  return {
    title: t("desgloseModalLiterals.title"),
    altCloseModal: t("desgloseModalLiterals.altCloseModal"),
    departureJourney: t("desgloseModalLiterals.departureJourney"),
    arrivalJourney: t("desgloseModalLiterals.arrivalJourney"),
    externalBuy: t("desgloseModalLiterals.externalBuy"),
    altExternalBuy: t("desgloseModalLiterals.altExternalBuy"),
    tooltipText: t("desgloseModalLiterals.tooltipText"),
    payNow: t("desgloseModalLiterals.payNow"),
    payLater: t("desgloseModalLiterals.payLater"),
    payTotal: t("desgloseModalLiterals.payTotal"),
    canceled: t("desgloseModalLiterals.canceled"),
    reserved: t("desgloseModalLiterals.reserved"),
    noReserved: t("desgloseModalLiterals.noReserved"),
    payDeparture: t("desgloseModalLiterals.payDeparture"),
    payReturn: t("desgloseModalLiterals.payReturn"),
    onlyOutwardTrip: t("desgloseModalLiterals.onlyOutwardTrip"),
    totalamount: t("desgloseModalLiterals.totalamount"),
    discount:t("desgloseModalLiterals.discount"),
    discountsUNKNOWN: t("desgloseModalLiterals.discountsUNKNOWN"),
    provisionedTooltip: t("desgloseModalLiterals.provisionedTooltip"),
  };
}

export function summaryTotalMock(t: any) {
  return {
    departure: {
      transports: [
        {
          transport: t("summaryTotalMock.departure.transports.0.transport"),
          details: [
            {
              text: t("summaryTotalMock.departure.transports.0.details.0.text"),
              external: t(
                "summaryTotalMock.departure.transports.0.details.0.external"
              ),
            },
          ],
        },
        {
          transport: t("summaryTotalMock.departure.transports.1.transport"),
          details: [
            {
              text: t("summaryTotalMock.departure.transports.1.details.0.text"),
              price: t(
                "summaryTotalMock.departure.transports.1.details.0.price"
              ),
              descriptionSection: {
                description: t(
                  "summaryTotalMock.departure.transports.1.details.0.descriptionSection.description"
                ),
                price: t(
                  "summaryTotalMock.departure.transports.1.details.0.descriptionSection.price"
                ),
              },
            },
            {
              text: t("summaryTotalMock.departure.transports.1.details.1.text"),
              price: t(
                "summaryTotalMock.departure.transports.1.details.1.price"
              ),
              alertStatus: t(
                "summaryTotalMock.departure.transports.1.details.1.alertStatus"
              ),
              descriptionSection: {
                description: t(
                  "summaryTotalMock.departure.transports.1.details.1.descriptionSection.description"
                ),
                price: t(
                  "summaryTotalMock.departure.transports.1.details.1.descriptionSection.price"
                ),
              },
            },
          ],
        },
        {
          transport: t("summaryTotalMock.departure.transports.2.transport"),
          details: [
            {
              text: t(
                "summaryTotalMock.departure.transports.2.transport.details.0.text"
              ),
              external: t(
                "summaryTotalMock.departure.transports.2.transport.details.0.external"
              ),
            },
          ],
        },
        {
          transport: t("summaryTotalMock.departure.transports.3.transport"),
          price: t("summaryTotalMock.departure.transports.3.price"),
        },
        {
          transport: t("summaryTotalMock.departure.transports.4.transport"),
          price: t("summaryTotalMock.departure.transports.4.price"),
        },
        {
          transport: t("summaryTotalMock.departure.transports.5.transport"),
          price: t("summaryTotalMock.departure.transports.5.price"),
        },
      ],
      desglose: {
        total: t("summaryTotalMock.departure.desglose.total"),
        now: t("summaryTotalMock.departure.desglose.now"),
        later: t("summaryTotalMock.departure.desglose.later"),
      },
    },
    arrival: t("summaryTotalMock.arrival"),
  };
}

export function outwardJourneyOption(t: any) {
  return [
    {
      code: t("outwardJourneyOption.0.code"),
      text: t("outwardJourneyOption.0.text"),
    },
    {
      code: t("outwardJourneyOption.1.code"),
      text: t("outwardJourneyOption.1.text"),
    },
  ];
}

export function choiceAllOption(t: any) {
  return [
    {
      code: t("choiceAllOption.0.code"),
      text: t("choiceAllOption.0.text"),
    },
    {
      code: t("choiceAllOption.1.code"),
      text: t("choiceAllOption.1.text"),
    },
    {
      code: t("choiceAllOption.2.code"),
      text: t("choiceAllOption.2.text"),
    },
  ];
}

export function initialDetailTMBLiterals(t: any) {
  return {
    title:  t("initialDetailTMBLiterals.title"),
    bookingTitle: t("initialDetailTMBLiterals.bookingTitle"),
    paymentMethodTitle:t("initialDetailTMBLiterals.paymentMethodTitle"),
    summaryPriceTitle:t("initialDetailTMBLiterals.summaryPriceTitle"),
    invoiceButton:t("initialDetailTMBLiterals.invoiceButton"),
    dateTitle:t("initialDetailTMBLiterals.dateTitle"),
    totalPrice:t("initialDetailTMBLiterals.totalPrice"),
    totalTicket:t("initialDetailTMBLiterals.totalTicket"),
    paymentMethod: t("initialDetailTMBLiterals.paymentMethodTitle"),
    summaryPrice: t("initialDetailTMBLiterals.summaryPriceTitle"),
    showCode:t("initialDetailTMBLiterals.showCode"),
    downloadReceipt: t("initialDetailTMBLiterals.downloadReceipt"),
    discount: t("desgloseModalLiterals.discount"),
    cancelTripModal: {
      title: t("initialDetailLiterals.cancelTripModal.title"),
      description: t("initialDetailLiterals.cancelTripModal.description"),
      buttons: [
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.0.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.0.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.0.text"),
        },
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.1.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.1.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.1.text"),
        },
      ],
    },
  };
}
export function initialDetailLiterals(t: any) {
  return {
    tripNotPay: {
      title: t("initialDetailLiterals.tripNotPay.title"),
      description: t("initialDetailLiterals.tripNotPay.description"),
    },
    reservationdate:t("desgloseModalLiterals.reservationdate"),
    title: t("initialDetailLiterals.title"),
    subTitle: t("initialDetailLiterals.subTitle"),
    showLess: t("initialDetailLiterals.showLess"),
    showMore: t("initialDetailLiterals.showMore"),
    button: t("initialDetailLiterals.button"),
    // choice: ["Resumen y pago", "Ida", "Vuelta"]
    choice: outwardJourneyOption(t),
    requestInvoiceText:t("initialDetailLiterals.requestInvoiceText"),
    cancelTripModal: {
      title: t("initialDetailLiterals.cancelTripModal.title"),
      description: t("initialDetailLiterals.cancelTripModal.description"),
      buttons: [
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.0.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.0.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.0.text"),
        },
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.1.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.1.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.1.text"),
        },
      ],
    },
    disclaimer:{
      title:t("initialDetailLiterals.disclaimer.title"),
      clientService:t("initialDetailLiterals.disclaimer.clientService"),
      url:t("initialDetailLiterals.disclaimer.url"),
    }
  };
}

export function initialGeneralLiterals(t: any) {
  return {
    buttontitle: t("initialGeneralLiterals.buttontitle"),
    title: t("initialGeneralLiterals.title"),
  };
}

export function initialPastTrips(t: any) {
  return [
    {
      dest: t("initialPastTrips.0.dest"),
      location: t("initialPastTrips.0.location"),
      price: t("initialPastTrips.0.price"),
      orderid: t("initialPastTrips.0.orderid"),
      departureDate: t("initialPastTrips.0.departureDate"),
      arrivalDate: t("initialPastTrips.0.arrivalDate"),
      numpassengers: t("initialPastTrips.0.numpassengers"),
      cancelation: t("initialPastTrips.0.cancelation"),
      returnticket: t("initialPastTrips.0.returnticket"),
      literals: {
        fromto: t("initialPastTrips.0.literals.fromto"),
        current: t("initialPastTrips.0.literals.current"),
        cancelations: t("initialPastTrips.0.literals.cancelations"),
      },
    },
    {
      dest: t("initialPastTrips.1.dest"),
      location: t("initialPastTrips.1.location"),
      price: t("initialPastTrips.1.price"),
      orderid: t("initialPastTrips.1.orderid"),
      departureDate: t("initialPastTrips.1.departureDate"),
      arrivalDate: t("initialPastTrips.1.arrivalDate"),
      numpassengers: t("initialPastTrips.1.numpassengers"),
      cancelation: t("initialPastTrips.1.cancelation"),
      returnticket: t("initialPastTrips.1.returnticket"),
      literals: {
        fromto: t("initialPastTrips.1.literals.fromto"),
        current: t("initialPastTrips.1.literals.current"),
        cancelations: t("initialPastTrips.1.literals.cancelations"),
      },
    },
    {
      dest: t("initialPastTrips.2.dest"),
      location: t("initialPastTrips.2.location"),
      price: t("initialPastTrips.2.price"),
      orderid: t("initialPastTrips.2.orderid"),
      departureDate: t("initialPastTrips.2.departureDate"),
      arrivalDate: t("initialPastTrips.2.arrivalDate"),
      numpassengers: t("initialPastTrips.2.numpassengers"),
      cancelation: t("initialPastTrips.2.cancelation"),
      returnticket: t("initialPastTrips.2.returnticket"),
      literals: {
        fromto: t("initialPastTrips.2.literals.fromto"),
        current: t("initialPastTrips.2.literals.current"),
        cancelations: t("initialPastTrips.2.literals.cancelations"),
      },
    },
    {
      dest: t("initialPastTrips.3.dest"),
      location: t("initialPastTrips.3.location"),
      price: t("initialPastTrips.3.price"),
      orderid: t("initialPastTrips.3.orderid"),
      departureDate: t("initialPastTrips.3.departureDate"),
      arrivalDate: t("initialPastTrips.3.arrivalDate"),
      numpassengers: t("initialPastTrips.3.numpassengers"),
      cancelation: t("initialPastTrips.3.cancelation"),
      returnticket: t("initialPastTrips.3.returnticket"),
      literals: {
        fromto: t("initialPastTrips.3.literals.fromto"),
        current: t("initialPastTrips.3.literals.current"),
        cancelations: t("initialPastTrips.3.literals.cancelations"),
      },
    },
    {
      dest: t("initialPastTrips.4.dest"),
      location: t("initialPastTrips.4.location"),
      price: t("initialPastTrips.4.price"),
      orderid: t("initialPastTrips.4.orderid"),
      departureDate: t("initialPastTrips.4.departureDate"),
      arrivalDate: t("initialPastTrips.4.arrivalDate"),
      numpassengers: t("initialPastTrips.4.numpassengers"),
      cancelation: t("initialPastTrips.4.cancelation"),
      returnticket: t("initialPastTrips.4.returnticket"),
      literals: {
        fromto: t("initialPastTrips.4.literals.fromto"),
        current: t("initialPastTrips.4.literals.current"),
        cancelations: t("initialPastTrips.4.literals.cancelations"),
      },
    },
  ];
}

export function initialInvoiceModalLiterals(t: any) {
  return {
    literals: {
      title: t("initialInvoiceModalLiterals.literals.title"),
      warningcercanias: t(
        "initialInvoiceModalLiterals.literals.warningcercanias"
      ),
      warningrenfe: t("initialInvoiceModalLiterals.literals.warningrenfe"),
      warningkarhoo: t("initialInvoiceModalLiterals.literals.warningkarhoo"),
      warningtaxi: t("initialInvoiceModalLiterals.literals.warningtaxi"),
      warningreby: t("initialInvoiceModalLiterals.literals.warningreby"),
      warningcooltra: t("initialInvoiceModalLiterals.literals.warningcooltra"),
      warningbolt: t("initialInvoiceModalLiterals.literals.warningbolt"),
      contact:t("initialInvoiceModalLiterals.literals.contact"),
      urlContact:t("initialInvoiceModalLiterals.literals.urlContact"),
      warningtier: t("initialInvoiceModalLiterals.literals.warningtier"),
      warningFreeNow: t("initialInvoiceModalLiterals.literals.warningFreeNow"),
    },
    filter: [
      {
        code: t("initialInvoiceModalLiterals.filter.0.code"),
        text: t("initialInvoiceModalLiterals.filter.0.text"),
      },
      {
        code: t("initialInvoiceModalLiterals.filter.1.code"),
        text: t("initialInvoiceModalLiterals.filter.1.text"),
      },
      {
        code: t("initialInvoiceModalLiterals.filter.2.code"),
        text: t("initialInvoiceModalLiterals.filter.2.text"),
      },
      {
        code: t("initialInvoiceModalLiterals.filter.3.code"),
        text: t("initialInvoiceModalLiterals.filter.3.text"),
      },
      {
        code: t("initialInvoiceModalLiterals.filter.4.code"),
        text: t("initialInvoiceModalLiterals.filter.4.text"),
      },
      {
        code: t("initialInvoiceModalLiterals.filter.5.code"),
        text: t("initialInvoiceModalLiterals.filter.5.text"),
      },
    ],
    cards: [
      {
        literals: {
          button: t("initialInvoiceModalLiterals.cards.0.literals.button"),
        },
        idcard: t("initialInvoiceModalLiterals.cards.0.idcard"),
        color: t("initialInvoiceModalLiterals.cards.0.color"),
        text: t("initialInvoiceModalLiterals.cards.0.text"),
        mode: t("initialInvoiceModalLiterals.cards.0.mode"),
        origin: t("initialInvoiceModalLiterals.cards.0.origin"),
        destination: t("initialInvoiceModalLiterals.cards.0.destination"),
        date: t("initialInvoiceModalLiterals.cards.0.date"),
        hour: t("initialInvoiceModalLiterals.cards.0.hour"),
      },
      {
        literals: {
          button: t("initialInvoiceModalLiterals.cards.1.literals.button"),
        },
        idcard: t("initialInvoiceModalLiterals.cards.1.idcard"),
        color: t("initialInvoiceModalLiterals.cards.1.color"),
        text: t("initialInvoiceModalLiterals.cards.1.text"),
        mode: t("initialInvoiceModalLiterals.cards.1.mode"),
        origin: t("initialInvoiceModalLiterals.cards.1.origin"),
        destination: t("initialInvoiceModalLiterals.cards.1.destination"),
        date: t("initialInvoiceModalLiterals.cards.1.date"),
        hour: t("initialInvoiceModalLiterals.cards.1.hour"),
      },
      {
        literals: {
          button: t("initialInvoiceModalLiterals.cards.2.literals.button"),
        },
        idcard: t("initialInvoiceModalLiterals.cards.2.idcard"),
        color: t("initialInvoiceModalLiterals.cards.2.color"),
        text: t("initialInvoiceModalLiterals.cards.2.text"),
        date: t("initialInvoiceModalLiterals.cards.2.date"),
        hour: t("initialInvoiceModalLiterals.cards.2.hour"),
      },
      {
        literals: {
          button: t("initialInvoiceModalLiterals.cards.3.literals.button"),
        },
        idcard: t("initialInvoiceModalLiterals.cards.3.idcard"),
        color: t("initialInvoiceModalLiterals.cards.3.color"),
        text: t("initialInvoiceModalLiterals.cards.3.text"),
        date: t("initialInvoiceModalLiterals.cards.3.date"),
        hour: t("initialInvoiceModalLiterals.cards.3.hour"),
      },
      {
        literals: {
          button: t("initialInvoiceModalLiterals.cards.4.literals.button"),
        },
        idcard: t("initialInvoiceModalLiterals.cards.4.idcard"),
        color: t("initialInvoiceModalLiterals.cards.4.color"),
        text: t("initialInvoiceModalLiterals.cards.4.text"),
        mode: t("initialInvoiceModalLiterals.cards.4.mode"),
        origin: t("initialInvoiceModalLiterals.cards.4.origin"),
        destination: t("initialInvoiceModalLiterals.cards.4.destination"),
        date: t("initialInvoiceModalLiterals.cards.4.date"),
        hour: t("initialInvoiceModalLiterals.cards.4.hour"),
      },
    ],
  };
}

export function invoiceModalButtonLiterals(t: any) {
  return {
    downloadInvoice: t("invoiceModalButtonLiterals.downloadInvoice"),
    sendForm: t("invoiceModalButtonLiterals.sendForm"),
    accesForm: t("invoiceModalButtonLiterals.accesForm"),
    contact: t("invoiceModalButtonLiterals.contact"),
    urlContact:t("initialInvoiceModalLiterals.literals.urlContact"),
  };
}

export function initialTicketsModalLiterals(t: any) {
  return {
    literals: {
      ticketLiterals: {
        cancelation: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.cancelation"
        ),
        reminder: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.reminder"
        ),
        title: t("initialTicketsModalLiterals.literals.ticketLiterals.title"),
        desc1: t("initialTicketsModalLiterals.literals.ticketLiterals.desc1"),
        desc2: t("initialTicketsModalLiterals.literals.ticketLiterals.desc2"),
        desc3: t("initialTicketsModalLiterals.literals.ticketLiterals.desc3"),
        desc4: t("initialTicketsModalLiterals.literals.ticketLiterals.desc4"),
        desc5: t("initialTicketsModalLiterals.literals.ticketLiterals.desc5"),
        item1: t("initialTicketsModalLiterals.literals.ticketLiterals.item1"),
        item2: t("initialTicketsModalLiterals.literals.ticketLiterals.item2"),
        item3: t("initialTicketsModalLiterals.literals.ticketLiterals.item3"),
        conditionButton: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.conditionButton"
        ),
        qrcanceltitle: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.qrcanceltitle"
        ),
        qrcanceldesc: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.qrcanceldesc"
        )
      },
      modalLiterals: {
        title: t("initialTicketsModalLiterals.literals.modalLiterals.title"),
        cancelButton: t(
          "initialTicketsModalLiterals.literals.modalLiterals.cancelButton"
        ),
        downloadButton: t(
          "initialTicketsModalLiterals.literals.modalLiterals.downloadButton"
        ),
      },
    },
  };
}

export function initialAveTicketsLiterals(t: any) {
  return {
    literals: {
      title: t("initialAveTicketsLiterals.literals.title"),
      desc: t("initialAveTicketsLiterals.literals.desc"),
      okbutton: t("initialAveTicketsLiterals.literals.okbutton"),
      cancelbutton: t("initialAveTicketsLiterals.literals.cancelbutton"),
    },
    passengers: [
      {
        id: t("initialAveTicketsLiterals.passengers.0.id"),
        fullname: t("initialAveTicketsLiterals.passengers.0.fullname"),
        ticketId: t("initialAveTicketsLiterals.passengers.0.ticketId"),
      },
    ],
  };
}

export function getInitialCancelModalLiterals(t: any) {
  return {
    title: t("getInitialCancelModalLiterals.title"),
    desc: t("getInitialCancelModalLiterals.desc"),
    cancelbutton: t("getInitialCancelModalLiterals.cancelbutton"),
    okbutton: t("getInitialCancelModalLiterals.okbutton"),
  };
}

export function initialDetailLiteralsAtom(t: any) {
  return {
    eachTime: t("initialDetailLiteralsAtom.eachTime"),
    // action: 'En la estación, coge el tren', // ¿Dinámico desde el servicio?
    delete: t("initialDetailLiteralsAtom.delete"),
    walkTransbordo: t("initialDetailLiteralsAtom.walkTransbordo"),
    walkDestination: t("initialDetailLiteralsAtom.walkDestination"),
    /* UI-ROUTE-START-END LITERALS */
    leaveFrom: t("initialDetailLiteralsAtom.leaveFrom"),
    arrivedAt: t("initialDetailLiteralsAtom.arrivedAt"),
    /* FIN  UI-ROUTE-START-END LITERALS */

    /* UI-STOPS LITERALS*/
    seeRoute: t("initialDetailLiteralsAtom.seeRoute"),
    step: t("initialDetailLiteralsAtom.step"),
    steps: t("initialDetailLiteralsAtom.steps"),
    direct: t("initialDetailLiteralsAtom.direct"),
    durationEstimated: t("initialDetailLiteralsAtom.durationEstimated"),
    actionStart: t("initialDetailLiteralsAtom.actionStart"),
    actionEnd: t("initialDetailLiteralsAtom.actionEnd"),
    altFoldIcon: t("initialDetailLiteralsAtom.altFoldIcon"),
    altUnfoldIcon: t("initialDetailLiteralsAtom.altUnfoldIcon"),
    drivingLicense: t("initialDetailLiteralsAtom.drivingLicense"),
    cancelled: t("initialDetailLiteralsAtom.cancelled"),
    tripId: t("initialDetailLiteralsAtom.tripId"),
    walkCheckIn: t("initialDetailLiteralsAtom.walkCheckIn"),
    paymentXpay:t("initialDetailLiteralsAtom.paymentXpay"),
    /* FIN UI-STOPS LITERALS */
  };
}

export function initialDetailLiteralsMyTrips(t: any) {
  return {
    title: t("initialDetailLiterals.title"),
    subTitle: t("initialDetailLiterals.subTitle"),
    button: t("initialDetailLiterals.button"),
    choice: [
      {
        code: t("initialDetailLiterals.choice.0.code"),
        text: t("initialDetailLiterals.choice.0.text"),
      },
    ],
    cancelTripModal: {
      title: t("initialDetailLiterals.cancelTripModal.title"),
      description: t("initialDetailLiterals.cancelTripModal.description"),
      buttons: [
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.0.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.0.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.0.text"),
        },
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.1.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.1.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.1.text"),
        },
      ],
    },
    headerButton: {
      id: t("initialDetailLiterals.cancelTripModal.headerButton.id"),
      text: t("initialDetailLiterals.cancelTripModal.headerButton.text"),
      type: t("initialDetailLiterals.cancelTripModal.headerButton.type"),
      el: t("initialDetailLiterals.cancelTripModal.headerButton.el"),
    },

    // TODO: cambiar literales
    cancelPstAveModal: {
      title: t("initialDetailLiterals.cancelPstAveModal.title"),
      desc: t("initialDetailLiterals.cancelPstAveModal.desc"),
      okbutton: t("initialDetailLiterals.cancelPstAveModal.okbutton"),
      cancelbutton: t("initialDetailLiterals.cancelPstAveModal.cancelbutton"),
    },
    cancelPstAskAveModal: {
      title: t("initialDetailLiterals.cancelPstAskAveModal.title"),
      description: t("initialDetailLiterals.cancelPstAskAveModal.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "outline",
          idButton: "cancel-button",
          type: "button",
          text:  t("initialDetailLiterals.cancelPstAskAveModal.buttons.0.text"),
          
        },
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text:t("initialDetailLiterals.cancelPstAskAveModal.buttons.1.text"),
        }
      ],
      toast:{
        textTitle:t("initialDetailLiterals.cancelPstAskAveModal.toast.textTitle"),

      }
    },
    cancelPstAskModal: {
      title: t("initialDetailLiterals.cancelPstAskModal.title"),
      description: t("initialDetailLiterals.cancelPstAskModal.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "outline",
          idButton: "cancel-button",
          type: "button",
          text:  t("initialDetailLiterals.cancelPstAskModal.buttons.0.text"),
        },
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text:  t("initialDetailLiterals.cancelPstAskModal.buttons.1.text"),
        }
      ]
    },
    cancelPstTaxiVtcAskModal: {
      title: t("initialDetailLiterals.cancelPstTaxiVtcAskModal.title"),
      description: t("initialDetailLiterals.cancelPstTaxiVtcAskModal.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "outline",
          idButton: "cancel-button",
          type: "button",
          text:  t("initialDetailLiterals.cancelPstTaxiVtcAskModal.buttons.0.text"),
        },
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text:  t("initialDetailLiterals.cancelPstTaxiVtcAskModal.buttons.1.text"),
        }
      ]
    },
    errorCancelation: {
      title: t("initialDetailLiterals.errorCancelation.title"),
      description: t("initialDetailLiterals.errorCancelation.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.errorCancelation.buttons.0.text"),
        }
      ]
    },
    alreadyCancelled: {
      title: t("initialDetailLiterals.alreadyCancelled.title"),
      description: t("initialDetailLiterals.alreadyCancelled.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.alreadyCancelled.buttons.0.text"),
        }
      ]
    }

  };
}



export const mock = {
  literals: {
    title: "Detalle del viaje",
    subTitle: "Detalle de la ruta",
    button: "Seleccionar ruta por",
    choice: ["Resumen y pago", "Ida", "Vuelta"],
  },
  detailLiterals: {
    eachTime: "Cada",
    // action: "En la estación, coge el tren", // ¿Dinámico desde el servicio?
    delete: "Eliminar de la planificación",
    walkTransbordo: "Tienes que andar {time} para hacer transbordo",
    walkDestination: "Camina {time} hacia {destination}",
    drivingLicense: "Necesitas el carnet de conducir",

    /* UI-ROUTE-START-END LITERALS */
    leaveFrom: "Salimos desde",
    arrivedAt: "Llegamos a",
    /* FIN  UI-ROUTE-START-END LITERALS */

    /* UI-STOPS LITERALS*/
    seeRoute: "Ver recorrido.",
    step: "parada.",
    steps: "paradas.",
    direct: "Trayecto directo.",
    durationEstimated: "Duración estimada.",
    altFoldIcon: "Plegar.",
    altUnfoldIcon: "Desplegar.",
    actionStart: "Subete en la parada",
    actionEnd: "Bajate en la parada",
    /* FIN UI-STOPS LITERALS */
  },
  detailData: [
    {
      idPst: "0",
      arrivalTime: "22:15",
      departureTime: "22:05",
      direction: "Madrid-Chamartín-Clara Campoamor",
      icon: "cercanias",
      transport: true,
      stops: ["Madrid-Sol", "Madrid-Chamartín-Clara Campoamor"],
      line: {
        text: "1",
        color: "red",
      },
      pricetag: {
        type: "info", // "button", "info", "warn"
        text: "Aprox. 1,50€",
      },
    },
    {
      idPst: "1",
      arrivalTime: "22:35",
      departureTime: "22:19",
      direction: "Madrid-Aeropuerto T4",
      icon: "cercanias",
      transport: true,
      stops: ["Madrid-Chamartín-Clara Campoamor", "Madrid-Aeropuerto T4"],
      line: {
        text: "1",
        color: "red",
      },
      pricetag: {
        type: "button", // "button", "info", "warn"
        text: "1,50€",
      },
      buttonsFooter: [
        {
          type: "button",
          styleButton: "outline",
          id: "watchTrip",
          text: "Ver billete",
          class: "col-auto",
        },
        {
          type: "button",
          styleButton: "link",
          id: "cancelTrip",
          text: "Cancelar trayecto",
          class: "col-auto",
        },
      ],
      classContentButtonsFooter: "justify-content-between",
      cancelled: true,
    },
  ],
};

export const tripSummaryMock = {
  literals: {
    reservationdate: "Fecha de reserva",
    paymethod: "Método de pago",
    summaryprice: "Resumen precio",
    totalticket: "Total billetes",
    cancelationfee: "Gastos de cancelación",
    discounts: "Descuentos",
    paid: "Abonado",
    pendingpay: "Pendiente de cobro",
    totalamount: "Precio total viaje",
    approx: "",
    breakdown: "Ver desglose",
    requestInvoiceText: "Solicitar facturas",
    showLess: 'Ocultar detalle',
    showMore: 'Mostrar detalle',
    tripDetail: 'Detalle del viaje'
  },
  date: "6 feb 2022",
  hour: "10:22",
  cardicon: "mastercard",
  cardname: "Master Card",
  cardnum: "373613562218288",
  totalticket: "139,70 €",
  cancelationfee: "2,00 €",
  discount: "- 69,20 €",
  paid: "",
  pendingpay: "",
  totalamount: "87,90 €",
  showRequestInvoiceButton: true,
  tripdate: "Viernes, 18 nov",
  triptime: 'hh:mm - hh:mm',
  travellers: '1'

};

export function NoTripsPageLiterals(t: any) {
  return {
    titlePage: t("NoTripsPageLiterals.titlePage"),
    title: t("NoTripsPageLiterals.title"),
    description: t("NoTripsPageLiterals.description"),
    description2: t("NoTripsPageLiterals.description2"),
    leftButton: {
      type: t("NoTripsPageLiterals.leftButton.type"),
      text: t("NoTripsPageLiterals.leftButton.text"),
      id: t("NoTripsPageLiterals.leftButton.id"),
    },
    imageSection: {
      name: t("NoTripsPageLiterals.imageSection.name"),
      alt: t("NoTripsPageLiterals.imageSection.alt"),
    },
  };
}

export function CallFailedPageLiterals(t: any) {
  return {
    titlePage: t("CallFailedPageLiterals.titlePage"),
    title: t("CallFailedPageLiterals.title"),
    description: t("CallFailedPageLiterals.description"),
    leftButton: {
      type: t("CallFailedPageLiterals.leftButton.type"),
      text: t("CallFailedPageLiterals.leftButton.text"),
      id: t("CallFailedPageLiterals.leftButton.id"),
    },
    imageSection: {
      name: t("CallFailedPageLiterals.imageSection.name"),
      alt: t("CallFailedPageLiterals.imageSection.alt"),
    },
  };
}

export function getFooterLiterals(t: any) {
  return {
    title: t("footer.title"),
    showPrivacyPolicyText: t("footer.showPrivacyPolicyText"),
    showLegalConditionsText: t("footer.showLegalConditionsText"),
    showCookiePolicyText: t("footer.showCookiePolicyText"),
    linkPrivacyPolicyText: "https://www.docomobility.com/es/privacidad",
    linkLegalConditionsText: "https://www.docomobility.com/es/terminos-y-condiciones",
    linkCookiePolicyText: "https://www.docomobility.com/es/politica-de-cookies",
  };
}


export function addZerosLeft(n: number | string) {
  n = n + '';
  return n.length >= 2 ? n : new Array(2 - n.length + 1).join('0') + n;
};
export function sessionLanguageMapping() {
  let lenguage = "";

  if (sessionStorage.getItem('raas-language') == 'en') {
    lenguage = 'en-GB';
    //Para el valenciano se pone el catalan
  } else if (sessionStorage.getItem('raas-language') == 'va') {
    lenguage = 'ca';
  } else {
    lenguage = sessionStorage.getItem('raas-language') || "es";
  }
  return lenguage;
}
export function formatTimeToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return `${addZerosLeft(dateObj.getHours())}:${addZerosLeft(dateObj.getMinutes())}`;
}
export function formatCompleteDateToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(sessionLanguageMapping(), { year: 'numeric', month: '2-digit', day: '2-digit' });
}
export function formatDateAndMonthToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(sessionLanguageMapping(), { month: 'short', day: 'numeric' });
}


export function getLiteralesErrorInvocesModalError1(t: any) {
  return {
    title: t("errorsInvoicesLiterals.error1.title"),
    desc: t("errorsInvoicesLiterals.error1.desc"),
    cancelbutton: t("errorsInvoicesLiterals.error1.cancelbutton"),
    okbutton: t("errorsInvoicesLiterals.error1.okbutton"),
  };
}
export function getLiteralesErrorInvocesModalError2(t: any) {
  return {
    title: t("errorsInvoicesLiterals.error2.title"),
    desc: t("errorsInvoicesLiterals.error2.desc"),
    cancelbutton: t("errorsInvoicesLiterals.error2.cancelbutton"),
    okbutton: t("errorsInvoicesLiterals.error2.okbutton"),
  };
}